export enum EnvName {
  production = 'production',
  mobile = 'mobile',
  staging = 'staging',
  mobile_staging = 'mobile_staging',
  tma_staging = 'tma_staging',
  qa = 'qa',
  aqa = 'aqa',
}
